import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import { PENDING, SUCCESS } from '../../../design-system/constants';
import { Loader } from '../../../design-system/Loader';
import {
    getAllMessageTemplatesRequest,
    patchMessageTemplateRequest,
} from '../../../resources/message-template/actions';
import {
    getMessageTemplateById,
    getMessageTemplateStatus,
    patchMessageTemplateStatus,
} from '../../../resources/message-template/selectors';
import { useAppDispatch, useAppSelector } from '../../../shared/redux';
import { BrowserHistoryReplace } from '../../../shared/routing/BrowserHistoryReplace';

import s from '../MessageTemplates.css';

import { Form } from './Form';

export const MessageTemplateEdit = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { messageTemplateId } = useParams<{ messageTemplateId: string }>();
    const messageTemplate = useAppSelector((state) =>
        getMessageTemplateById(state, messageTemplateId),
    );
    const getStatus = useAppSelector(getMessageTemplateStatus);
    const patchStatus = useAppSelector((state) =>
        patchMessageTemplateStatus(state, messageTemplateId),
    );
    useEffect(() => {
        dispatch(getAllMessageTemplatesRequest());
    }, [dispatch]);

    const hasTemplate = typeof messageTemplate !== 'undefined' || getStatus === SUCCESS;
    const displayLoader = typeof messageTemplate === 'undefined' && getStatus === PENDING;
    const isSubmitting = patchStatus === PENDING;
    const submitUpdateMessageTemplate = ({ title, content }: { title: string; content: string }) =>
        dispatch(
            patchMessageTemplateRequest({
                ...messageTemplate,
                title,
                content,
            }),
        );

    if (typeof messageTemplate === 'undefined' && getStatus === SUCCESS) {
        return <BrowserHistoryReplace to="/templates/list" />;
    }

    return (
        <div className={s.messageTemplateFormContainer}>
            <h1 className={s.title}>
                <FormattedMessage id="templates.bo.edit" />
            </h1>
            {hasTemplate && (
                <Form
                    initialTitle={messageTemplate.title}
                    initialContent={messageTemplate.content}
                    submit={submitUpdateMessageTemplate}
                    isSubmitting={isSubmitting}
                />
            )}
            {displayLoader && (
                <div className={s.centerContainer}>
                    <Loader className={s.loader} />
                </div>
            )}
        </div>
    );
};
